<template>
  <card type="projects-button-block">
    <form @submit.prevent>
      <div class="row">
        <div class="col-lg-8 ml-auto mr-auto">
          <div class="row">
            <div class="col-md-4">
              <base-button v-if="timeStarted" class="clock-button" size="lg" disabled simple block type="primary" @click="startClock">
                <i class="tim-icons icon-triangle-right-17"></i> Start clock
              </base-button>
              <base-button v-else class="clock-button" size="lg" simple block type="primary" @click="startClock">
                <i class="tim-icons icon-triangle-right-17"></i> Start clock
              </base-button>
            </div>
            <div class="col-md-4">
              <base-button v-if="timeStarted" class="clock-button" size="lg" simple block type="primary" @click="stopClock">
                <i class="tim-icons icon-button-pause"></i> Stop clock
              </base-button>
              <base-button v-else class="clock-button" size="lg" disabled simple block type="primary" @click="stopClock">
                <i class="tim-icons icon-button-pause"></i> Stop clock
              </base-button>
            </div>
            <div class="col-md-4">
              <base-button class="clock-button" size="lg" simple block type="primary" @click="addClock">
                <i class="tim-icons icon-pencil"></i> Add clock
              </base-button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </card>
</template>

<script>
    export default {
      props: ['timeStarted'],
      name: "buttons-block",
      methods:{
        startClock(){
          this.$emit('start-clock');
        },
        stopClock(){
          this.$emit('stop-clock');
        },
        addClock(){
          this.$emit('add-clock');
        },
      }
    }
</script>

<style scoped>
  i {
    font-size: 30px;
    margin-left: -30px;
  }
  .clock-button {
    min-width: 149px;
  }
</style>
